export default function account(store, ownProps) {
	return store.account;
}